import React from "react";
import { useParams } from "react-router";
import useProjectActions from "../hooks/useProjectActions";
import useFirebaseProject from "../hooks/useFirebaseProject";

import MaterialForm from "./MaterialForm";

const MaterialEditPage = () => {
  const { project_id, material_id } = useParams();
  const { editProject } = useProjectActions();
  const project = useFirebaseProject(project_id!);

  const glass_type = project?.materials?.[material_id!]?.glass || project?.glass;
  const handleSubmit = (formValues: any) => {
    const new_project = { ...project };
    const new_material = { ...formValues, glass: glass_type };
    new_project.materials = {
      ...new_project.materials,
      [material_id!]: new_material,
    };
    editProject(project_id!, new_project);
  };
  if (!project) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <MaterialForm
        onSubmit={handleSubmit}
        initialValues={{
          description: project.materials?.[material_id!]?.description,
          glass_reference: project.materials?.[material_id!]?.glass_reference,
        }}
        glass_type={glass_type}
      />
    </div>
  );
};

export default MaterialEditPage;
